import React from 'react';
import { Chip } from '@mui/material';
import { useLanguage } from '../context/LanguageContext';

const statusConfig = {
  // Order Statuses
  Draft: { labelAr: 'مسودة', labelEn: 'Draft', color: '#64748B', bg: '#F1F5F9', border: '#CBD5E1' },
  PendingDispatch: { labelAr: 'بانتظار الإسناد', labelEn: 'Pending Dispatch', color: '#D97706', bg: '#FEF3C7', border: '#FDE68A' },
  Offered: { labelAr: 'تم العرض للمناديب', labelEn: 'Offered', color: '#2563EB', bg: '#DBEAFE', border: '#BFDBFE' },
  Accepted: { labelAr: 'تم قبول العرض', labelEn: 'Accepted', color: '#0D9488', bg: '#CCFBF1', border: '#99F6E4' },
  CourierAtPickup: { labelAr: 'المندوب بالمطعم', labelEn: 'At Restaurant', color: '#7C3AED', bg: '#EDE9FE', border: '#DDD6FE' },
  PickedUp: { labelAr: 'تم الاستلام (قيد التوصيل)', labelEn: 'In Transit', color: '#EA580C', bg: '#FFEDD5', border: '#FED7AA' },
  ArrivedDelivery: { labelAr: 'المندوب عند العميل', labelEn: 'Arrived Delivery', color: '#4F46E5', bg: '#EEF2FF', border: '#E0E7FF' },
  Delivered: { labelAr: 'تم التسليم بنجاح', labelEn: 'Delivered', color: '#16A34A', bg: '#DCFCE7', border: '#BBF7D0' },
  FailedAttempt: { labelAr: 'محاولة فاشلة', labelEn: 'Failed Attempt', color: '#DC2626', bg: '#FEE2E2', border: '#FECACA' },
  ReturnedToRestaurant: { labelAr: 'مرتجع للمطعم', labelEn: 'Returned', color: '#9333EA', bg: '#F3E8FF', border: '#E9D5FF' },
  Cancelled: { labelAr: 'ملغي', labelEn: 'Cancelled', color: '#EF4444', bg: '#FEE2E2', border: '#FECACA' },

  // Courier Statuses
  Online: { labelAr: 'متاح للطلبات', labelEn: 'Online / Available', color: '#16A34A', bg: '#DCFCE7', border: '#BBF7D0' },
  Busy: { labelAr: 'في مهمة توصيل', labelEn: 'Busy on Trip', color: '#EA580C', bg: '#FFEDD5', border: '#FED7AA' },
  Offline: { labelAr: 'غير متاح (مغلق)', labelEn: 'Offline', color: '#64748B', bg: '#F1F5F9', border: '#CBD5E1' },

  // Verification & Document Statuses
  Approved: { labelAr: 'معتمد وموثق', labelEn: 'Approved', color: '#16A34A', bg: '#DCFCE7', border: '#BBF7D0' },
  PendingReview: { labelAr: 'قيد المراجعة', labelEn: 'Under Review', color: '#D97706', bg: '#FEF3C7', border: '#FDE68A' },
  Rejected: { labelAr: 'مرفوض', labelEn: 'Rejected', color: '#EF4444', bg: '#FEE2E2', border: '#FECACA' },
  Active: { labelAr: 'نشط', labelEn: 'Active', color: '#16A34A', bg: '#DCFCE7', border: '#BBF7D0' },
  Inactive: { labelAr: 'معطل', labelEn: 'Inactive', color: '#64748B', bg: '#F1F5F9', border: '#CBD5E1' },
};

const StatusBadge = ({ status, size = 'small' }) => {
  const { language } = useLanguage();
  const config = statusConfig[status];

  const label = config
    ? (language === 'en' ? config.labelEn : config.labelAr)
    : (status || (language === 'en' ? 'Unassigned' : 'غير محدد'));

  const color = config ? config.color : '#64748B';
  const bg = config ? config.bg : '#F1F5F9';
  const border = config ? config.border : '#CBD5E1';

  return (
    <Chip
      size={size}
      label={label}
      sx={{
        fontWeight: 700,
        fontSize: size === 'small' ? '0.75rem' : '0.85rem',
        color: color,
        backgroundColor: bg,
        border: `1px solid ${border}`,
        height: size === 'small' ? 24 : 30,
        '& .MuiChip-label': {
          paddingLeft: '8px',
          paddingRight: '8px',
        },
      }}
    />
  );
};

export default StatusBadge;
